import { createApi, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { apiSlice } from "../../app/api/apiSlice";

const iconToWeatherType = {
    50: "sunny",
    51: "cloudy",
    52: "cloudy",
    53: "rainy",
    54: "rainy",
    60: "cloudy",
    61: "cloudy",
    62: "rainy",
    63: "rainy",
    64: "rainy",
    65: "thunderstorm",
    70: "sunny",
    71: "sunny",
    72: "sunny",
    73: "sunny",
    74: "sunny",
    75: "sunny",
    76: "cloudy",
    77: "sunny",
}

export const WeatherSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getWeatherInfo: builder.query<any, string>({
            query: (workScheduleId) => `/weather/workSchedule/${workScheduleId}`,
            transformResponse: (data: any, meta, arg) => {
                return {
                    temperature: data.temperature,
                    humidity: data.humidity,
                    rainfall: data.rainfall,
                    pm2_5: data.pm2_5,
                    weatherType: (iconToWeatherType as any)[data.icon],
                }
            },
        })
    })
})

export const {
    useGetWeatherInfoQuery
} = WeatherSlice